import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import keycloakInst from "./components/Service/keycloak";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { AuthProvider } from "./context/AuthContext";
const initOptions = { onLoad: "login-required" };

const hourAgo = new Date().getTime() - 3600000;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      initialDataUpdatedAt: hourAgo,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <ReactKeycloakProvider authClient={keycloakInst} initOptions={initOptions}>
  <QueryClientProvider client={queryClient}>
    {/* <AuthProvider> */}
    <App />
    {/* </AuthProvider> */}
  </QueryClientProvider>
  // </ReactKeycloakProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
